import React from "react";
import AuthorizationCheck from "../auth/authorizationCheck";
import CountryService from "../services/country";
import BranchService from "../services/branch";
import $ from 'jquery';
import Utility from "../utilities/utility";

class BranchUpdate extends React.Component {

    constructor(props) {
        super(props);

        const queryParams = new URLSearchParams(window.location.search);

        this.branchId = queryParams.get('branchId');


        this.countryService = new CountryService();
        this.branchService = new BranchService();
        this.state = {

            countries: [],
            currentUserRole: '',
            branch: []

        };
    }

    componentDidMount() {

        this.fetchCountries();

        this.fetchBranch();

    }

    fetchCountries = async () => {

        try {

            const response = await this.countryService.fetchCountries();

            this.setState({
                countries: await response.json()
            });

        } catch (error) {
            console.log(error)
        }

    }

    fetchBranch = async () => {

        try {

            const response = await this.branchService.fetchBranch(this.branchId);

            this.setState({
                branch: await response.json()
            });

        } catch (error) {
            console.log(error)
        }

    }


    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    update = async (branchId, e) => {

        e.preventDefault();

        try {

            let name = $('#branchName').val();

            let countryId = $('#countryId').val();

            const response = await this.branchService.updateBranch(branchId, countryId, name);

            if(response.ok){

                Utility.showAlertWithId('messageHolder', 'Branche info mise a jour', 'success', true);
            }else{

                Utility.showAlertWithId('messageHolder', 'Probleme lors du mise a jour', 'danger', true);
            }
        } catch (error) {

        }
    }

    render() {

        const branch = this.state.branch;

        return (
            <div className="form-wrapper">

                <h2>Branche Mis a jour</h2>

                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />

                <div className='container'>
                    <div id="messageHolder"></div>



                    <div className="form-group row">

                        <input type="text" className="form-control" id="branchName" defaultValue={branch.name} placeholder="Nom de la branche" />

                    </div>




                    <div className="form-group row">
                        <label className="label">Pays</label>
                        <select className="form-control full-width" id="countryId">
                            <option></option>
                            {this.state.countries.length > 0 && this.state.countries.map(country => {


                                if (country.countryId == branch.countryId) {

                                    return <option key={country.countryId} selected={true} value={country.countryId}>{country.name}</option>

                                }


                                return <option key={country.countryId} value={country.countryId}>{country.name}</option>



                            })}
                        </select>

                    </div>


                    <div className="form-group row">
                        <button className="btn btn-primary" onClick={(e) => this.update(branch.branchId, e)}>Update</button>
                    </div>

                </div>

            </div>
        )
    }

}

export default BranchUpdate;